import React, { useCallback, useEffect, useState } from 'react'
import { Paper, Table, TableBody, TableContainer, Tooltip } from '@mui/material'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import CustomTableHeader from '../CustomTableHeader/CustomTableHeader'
import './CustomTable.scss'
import { format } from 'date-fns'

function CustomTable(props) {
  const { data, dataStateSetter, columns, tableSize, orderByDefaultProperty, timeZone } = props
  const [order, setOrder] = useState({ direction: '', property: '' })
  const [showToolTip, setShowToolTip ] = useState(false)

  let dataCopy = [...data]
  const handleRequestSort = (event, property) => {
    const isAsc = order.property === property && order.direction === 'desc'
    setOrder({ direction: isAsc ? 'asc' : 'desc', property })
  }

  const compare = (a, b) => {
    if (order.direction === 'asc') {
      return Date.parse(a[order.property]) && Date.parse(b[order.property])
        ? Date.parse(a[order.property]) - Date.parse(b[order.property])
        : a[order.property].localeCompare(b[order.property])
    } else {
      return Date.parse(a[order.property]) && Date.parse(b[order.property])
        ? Date.parse(b[order.property]) - Date.parse(a[order.property])
        : b[order.property].localeCompare(a[order.property])
    }
  }

  const compareAddress = (a, b) => {
    if (order.direction === 'asc') {
      return formatAddress(a[order.property]).localeCompare(formatAddress(b[order.property]))
    } else {
      return formatAddress(b[order.property]).localeCompare(formatAddress(a[order.property]))
    }
  }

  useEffect(() => {
    handleRequestSort(null, orderByDefaultProperty)
  }, [])

  useEffect(() => {
   if(props?.sectionType !== 'recruitment'){
     setShowToolTip(true)
   } else {
     setShowToolTip(false)
   }
  }, [data])

  useEffect(() => {
    if (order && order.property && order.direction) {
      if (order.property === 'residentialPlanAddress') {
        const sortedDataByAddress = dataCopy.sort(compareAddress)
        dataStateSetter(sortedDataByAddress)
      } else {
        const sortedData = dataCopy.sort(compare)
        dataStateSetter(sortedData)
      }
    }
  }, [order])

  const setMultiFamilyUnit = (elem, isOther) => {
    switch (elem) {
      case 1:
        return 'Front'
      case 2:
        return 'Rear'
      case 3:
        return 'Left'
      case 4:
        return 'Right'
      case 5:
        return 'Middle Unit'
      case 6:
        return 'Basement Unit'
      case 7:
        return 'First Floor'
      case 8:
        return 'Second Floor'
      case 9:
        return ` ${isOther}`
      default:
        return ''
    }
  }

  const formatAddress = (row) => {
    if (row) {
      const address = `${row.streetNumber !== null ? `${row.streetNumber}, ` : ''}${
        row.streetName !== null ? `${row.streetName}, ` : ''
      }${
        row.multiUnitType && row.multiUnitType.length > 0
          ? row.multiUnitType
              .map((elem) => {
                const isOther = row.multiUnitTypeOther && row.multiUnitTypeOther
                return `${setMultiFamilyUnit(elem, isOther)}, `
              })
              .join('')
          : ''
      }${row.apartmentNumber !== null ? `Apartment: ${row.apartmentNumber}, ` : ''}${
        row.unitNumber !== null && row.unitNumber !== '' && row.unitNumber !== undefined
          ? `Unit: ${row.unitNumber}, `
          : ''
      }${row.floor !== null ? `Floor: ${row.floor}, ` : ''}${
        row.city !== null ? `${row.city}, ` : ''
      }${row.state !== null ? `${row.state}, ` : ''}${row.country !== null ? `${row.country}` : ''}`
      return address
    }
  }
  const formatDate = useCallback(
    (date) => {
      const dateObj = new Date(date)

      if (timeZone) {
        const serverOffset = timeZone * 60000
        const localOffset = new Date().getTimezoneOffset() * 60000
        const resultMilliseconds = dateObj.getTime() + serverOffset + localOffset
        return format(resultMilliseconds, 'HH:mm MMM dd, y')
      }
      return format(dateObj, 'HH:mm MMM dd, y')
    },
    [timeZone]
  )

  return (
    <TableContainer component={Paper} className="custom-table">
      <Table size={tableSize}>
        <CustomTableHeader
          columns={columns}
          order={order.direction}
          orderBy={order.property}
          onRequestSort={handleRequestSort}
        />
        <TableBody>
          {Array.isArray(data) &&
            data.length > 0 &&
            data.map((row) => (
              <TableRow key={row._id} hover>
                {Array.isArray(columns) &&
                  columns.length > 0 &&
                  columns.map((column) => {
                    switch (column.type) {
                      case 'date':
                        return (
                          <TableCell key={row.id + column.id}>
                            {formatDate(row[column.id])}
                          </TableCell>
                        )
                      case 'object':
                        return (
                          <TableCell key={row.id + column.id}>
                            {formatAddress(row[column.id])}
                          </TableCell>
                        )
                      default:
                        if (showToolTip && column.id === 'currentSectionName') {
                          return (
                            <Tooltip
                              className="table-tooltip"
                              arrow
                              title={
                                <div
                                  style={{
                                    padding: '4px 10px',
                                    fontSize: 14
                                  }}
                                >
                                  {row[column.id]}
                                </div>
                              }
                              key={row.id + column.id}
                            >
                              <TableCell
                                className={'table-cell-section-Name'}
                                key={row.id + column.id}
                              >
                                {row[column.id]}
                              </TableCell>
                            </Tooltip>
                          )
                        } else {
                          return <TableCell key={row.id + column.id}>{row[column.id]}</TableCell>
                        }
                    }
                  })}
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default CustomTable
